<template>
<div id="container"><!-- [D]left menu collapse : <div id="container" class="snb_collapsed"> -->
    <div class="container_wrap">
        <!-- snb -->
        <skp-snb></skp-snb>

        <!-- contents -->
        <div id="contents">
            <!-- 200416수정(div 위치이동 및 추가) S -->
            <div class="mainTop_box">
                <header>
                    <h3>{{ $t('TITLE.HOME.KPI') }}</h3>
                </header>
                <div v-if="isChartLoading" class="row_no_margin">
                    <div class="nodata">
                        <!-- 200708수정(loading) S -->
                        <span class="loader_box">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </span>
                        <!-- 200708수정(loading) E -->
                    </div>
                </div>
                <div v-else class="row_no_margin" id="slide">
                    <!--
                        ┌────────┬───────────────────────────────────────────┬───────────────────────┐
                        | Chart  | Title                                     | Chart Type            |
                        ├────────┼───────────────────────────────────────────┼───────────────────────┤
                        | IC     | 'Views on @TITLE@ Important Knowledge'    | Horizontal Bar Chart  |
                        | MRC    | 'Views on @TITLE@ Must Read Knowledge'    | Horizontal Bar Chart  |
                        | CS     | 'Contents Satisfaction on @TITLE@'        | Horizontal Bar Chart  |
                        | ICO    | 'Views on @TITLE@'                        | Doughnut/Pie chart    |
                        | MRCO   | 'Views on @TITLE@'                        | Doughnut/Pie chart    |
                        | QA     | 'Q&A Status on @TITLE@'                   | Doughnut/Pie chart    |
                        | CU     | 'Contents Usage on @TITLE@'               | Vertical Bar Chart    |
                        | RE     | 'Reprocessing Ratio on @TITLE@'           | Vertical Bar Chart    |
                        | CC     | 'Contents Creation on @TITLE@'            | Polar Area chart      |
                        └────────┴───────────────────────────────────────────┴───────────────────────┘
                        다이나믹 KPI 차트 목록
                        - KPI 별 차트가 상이함, 유형에 맞는 차트에 데이터를 건내주어 출력하는 방식
                        - Polar Area 형태의 차트는 확인이 필요함.
                        - Title CSS 적용은 미지수
                    -->
                    <div v-for="(chart, idx) in myChartList" class="col-4 col-sm-auto" @dblclick="goToDetailPage(chart)">
                        <div class="service_block">
                            <div class="chart-block">
                                <horizontal-chart v-if="['IC', 'MRC', 'CS'].includes(chart.chartType)" :chart="chart" :settings="myChartSettings.rowData[idx]" :styles="chartStyles"></horizontal-chart>
                                <doughnut-chart v-if="['ICO', 'MRCO', 'QA'].includes(chart.chartType)" :chart="chart" :settings="myChartSettings.rowData[idx]" :styles="chartStyles"></doughnut-chart>
                                <vertical-chart v-if="['CU', 'RE'].includes(chart.chartType)" :chart="chart" :settings="myChartSettings.rowData[idx]" :styles="chartStyles"></vertical-chart>
                                <polar-chart v-if="['CC'].includes(chart.chartType)" :chart="chart" :settings="myChartSettings.rowData[idx]" :styles="chartStyles"></polar-chart>
                                <!-- 도넛형태 차트 대신 파이 형태로 변경할 시, 상기 도넛 차트 부분을 주석처리하고 하기 태그를 주석 해제한다.
                                <pie-chart v-if="['ICO', 'MRCO', 'QA'].includes(chart.chartType)" :chart="chart" :settings="myChartSettings.rowData[idx]" :styles="chartStyles"></pie-chart>
                                -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dots-wrap"></div>
                <!-- 20.06.04 Chart 로딩이 끝난 후 설정 아이콘이 뜰 수 있도록 -->
                <a v-if="!isChartLoading" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnDashboardConfig">
                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                </a>
            </div>
            <!-- //200416수정 E -->

            <!--
                다이나믹 컨텐츠 목록 출력
                - Config 팝업은 화면설계서 MY-003-P-C 참고 (5/6 기준 156 페이지)
                - 非ASC
                    - 4개 컨텐츠 (Hot Contents, Work Board, Support, New & Update Contents) 중 3개만 선택하여 리스트 표시
                    - 모바일 탭 리스트도 선택된 항목만 나옴
                    - TN_CMN_MY_SETUP ( WORK_TYPE: CONTENT, WORK_KEY1 ~ 3: H/W/S/N )
                - ASC
                    - 4개 컨텐츠 (Hot Contents, my Favorite Contents, New & Update Contents, Support) 중 3개만 선택하여 리스트 표시
                    - 모바일 탭 리스트도 선택된 항목만 나옴
                    - TN_CMN_MY_SETUP ( WORK_TYPE: ASC_CONTENT, WORK_KEY1 ~ 3: H/F/N/S )
            -->
            <div v-if="isContentsLoading" class="mainTop_box mt-20">
                <div class="row_no_margin">
                    <div class="nodata">
                        <!-- 200708수정(loading) S -->
                        <span class="loader_box">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </span>
                        <!-- 200708수정(loading) E -->
                    </div>
                </div>
            </div>
            <div v-else class="row mainBtm_box">
                <div class="col-12 service_tab">
                    <div class="service_block">
                        <ul class="tab_list">
                            <li :class="idx === 0 ? 'active' : ''" v-for="(cont, idx) in myContentsList">
                                <a v-if="cont.WORK_KEY === 'H'" href="javascript:" :rel="idx+2">{{ $t('FIELD.DASHBOARD.HOT.CONTENTS') }}</a>
                                <a v-if="cont.WORK_KEY === 'W'" href="javascript:" :rel="idx+2">{{ $t('FIELD.DASHBOARD.WORKBOARD') }}</a>
                                <a v-if="cont.WORK_KEY === 'S'" href="javascript:" :rel="idx+2">{{ $t('FIELD.DASHBOARD.SUPPORT') }}</a>
                                <a v-if="cont.WORK_KEY === 'N'" href="javascript:" :rel="idx+2">{{ $t('FIELD.DASHBOARD.NEW.UPDATE') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <template v-for="(cont, idx) in myContentsList">
                    <div v-if="cont.WORK_KEY === 'H'" class="col-4 col-md-12 col-sm-12 tab_content">
                        <a v-if="idx === (myContentsList.length - 1)" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                        </a>
                        <div class="service_block">
                            <header>
                                <h3>{{ $t('FIELD.DASHBOARD.HOT.CONTENTS') }}</h3>
                            </header>
                            <fragment v-if="!hotReady">
                                <ul class="ul_list">
                                    <li class="nodata">
                                        <!-- 200708수정(loading) S -->
                                        <span class="loader_box">
                                            <div class="loader"><span class="sr_only">Loading...</span></div>
                                        </span>
                                        <!-- 200708수정(loading) E -->
                                    </li>
                                </ul>
                            </fragment>
                            <fragment v-else>
                            <ul v-if="hotContentsList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in hotContentsList">
                                    <span class="subject">
                                        <a href="javascript:" @click="popHotContents(content, 'H')">
                                            <em v-if="content.HOT_TYPE === 'R'" class="textbgbox_recommend">R</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <em v-if="content.HOT_TYPE === 'R'" class="textbgbox_recommend">R</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                            </fragment>
                        </div>
                    </div>
                    <div v-if="cont.WORK_KEY === 'W'" class="col-4 col-md-12 col-sm-12 tab_content">
                        <a v-if="idx === (myContentsList.length - 1)" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                        </a>
                        <div class="service_block">
                            <header>
                                <h3>{{ $t('FIELD.DASHBOARD.WORKBOARD') }}</h3>
                            </header>
                            <fragment v-if="!workReady">
                                <ul class="ul_list">
                                    <li class="nodata">
                                        <!-- 200708수정(loading) S -->
                                        <span class="loader_box">
                                            <div class="loader"><span class="sr_only">Loading...</span></div>
                                        </span>
                                        <!-- 200708수정(loading) E -->
                                    </li>
                                </ul>
                            </fragment>
                            <fragment v-else>
                            <ul v-if="workBoardList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in workBoardList">
                                    <span class="subject">
                                        <a href="javascript:" @click="popHotContents(content, 'W')">
                                            <!--
                                            <em class="textbox_fix">Fix</em>
                                            <em class="textbox_rejected">Rejected</em>
                                            <em class="textbox_processing">Processing</em>
                                            <em class="textbox_complete">Complete</em>
                                            <em class="textbox_canceled">Canceled</em>
                                            -->
                                            <em v-if="content.TYPE === 1 && content.SHARE_ID !== undefined" class="textbox_request">{{ $t('FIELD.GLOBAL.REQUEST.SHARING') }}</em>
                                            <em v-else-if="content.TYPE === 1 && content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.TYPE === 1 && content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            <em v-else-if="content.TYPE === 2" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            <em v-else-if="content.TYPE === 3" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <!--
                                            <em class="textbox_fix">Fix</em>
                                            <em class="textbox_rejected">Rejected</em>
                                            <em class="textbox_processing">Processing</em>
                                            <em class="textbox_complete">Complete</em>
                                            <em class="textbox_canceled">Canceled</em>
                                            -->
                                            <em v-if="content.TYPE === 1 && content.SHARE_ID !== undefined" class="textbox_request">{{ $t('FIELD.GLOBAL.REQUEST.SHARING') }}</em>
                                            <em v-else-if="content.TYPE === 1 && content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.TYPE === 1 && content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            <em v-else-if="content.TYPE === 2" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            <em v-else-if="content.TYPE === 3" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                            </fragment>
                        </div>
                    </div>
                    <div v-if="cont.WORK_KEY === 'S'" class="col-4 col-md-12 col-sm-12 tab_content">
                        <a v-if="idx === (myContentsList.length - 1)" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                        </a>
                        <!-- 200416수정(아이콘 추가) -->
                        <div class="service_block">
                            <header>
                                <h3>{{ $t('FIELD.DASHBOARD.SUPPORT') }}</h3>
                            </header>
                            <fragment v-if="!supReady">
                                <ul class="ul_list">
                                    <li class="nodata">
                                        <!-- 200708수정(loading) S -->
                                        <span class="loader_box">
                                            <div class="loader"><span class="sr_only">Loading...</span></div>
                                        </span>
                                        <!-- 200708수정(loading) E -->
                                    </li>
                                </ul>
                            </fragment>
                            <fragment v-else>
                            <ul v-if="supportList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in supportList">
                                    <span class="subject">
                                        <a href="javascript:" @click="popSupport(content.KEY, content.KEY_TYPE)">
                                            <em v-if="content.STATUS === 'Replied'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Inquiry'" class="textcolor_check">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Warning'" class="textcolor_warning">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Answered'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Commented'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            {{ content.TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <em v-if="content.STATUS === 'Replied'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Inquiry'" class="textcolor_check">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Warning'" class="textcolor_warning">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Answered'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Commented'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            {{ content.TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                            </fragment>
                        </div>
                    </div>
                    <div v-if="cont.WORK_KEY === 'N'" class="col-4 col-md-12 col-sm-12 tab_content">
                        <a v-if="idx === (myContentsList.length - 1)" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                            <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                        </a>
                        <!-- 200416수정(아이콘 추가) -->
                        <div class="service_block">
                            <header>
                                <h3>{{ $t('FIELD.DASHBOARD.NEW.UPDATE') }}</h3>
                            </header>
                            <fragment v-if="!newReady">
                                <ul class="ul_list">
                                    <li class="nodata">
                                        <!-- 200708수정(loading) S -->
                                        <span class="loader_box">
                                            <div class="loader"><span class="sr_only">Loading...</span></div>
                                        </span>
                                        <!-- 200708수정(loading) E -->
                                    </li>
                                </ul>
                            </fragment>
                            <fragment v-else>
                            <ul v-if="newUpdateList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in newUpdateList">
                                    <span class="subject">
                                        <a href="javascript:" @click="popNewUpdateContents(content)">
                                            <em v-if="content.ICO_TYPE === 'U'" class="textbgbox_update">U</em>
                                            <em v-else-if="content.ICO_TYPE === 'N'" class="textbgbox_new">N</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                            </fragment>
                        </div>
                    </div>
                </template>

            </div>
        </div>
        <!-- contents -->
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import SKPSnb                               from '~vb/main/SKPSnb';

import DashboardConfigPopup                 from './popup/DashboardConfigPopup';
import ContentsConfigPopup                  from './popup/ContentsConfigPopup';
import answerDetailPopup                    from '~vb/faq/popup/answerDetailPopup';
import questionDetailPopup                  from '~vb/faq/popup/questionDetailPopup';
import communicationPopup                   from '~vb/faq/popup/communicationPopup';
import viewFaqPopup                         from '~vb/faq/popup/viewFaqPopup';

import PieChart                             from './charts/PieChart';
import DoughnutChart                        from './charts/DoughnutChart';
import HorizontalBarChart                   from './charts/HorizontalBarChart';
import VerticalBarChart                     from './charts/VerticalBarChart';
import PolarAreaChart                       from './charts/PolarAreaChart';

import KnowledgeDetailPopup                 from '~vb/knowledge/popup/KnowledgeDetailPopup';
import BulletinViewPopup                    from '~vb/anysvcmobile/svcBulletin/BulletinViewPopup';
import RequestSharingFromPopup              from '~vb/common/RequestSharingFromPopup';

const fetchMySetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/main/getMySetting.skp`,
    qs.stringify({ workType: workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const fetchContentsList = params => axios.post(
    `${SDLUtil.API_URL}/basis/main/listDashboardContents.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'Dashboard',
    data() {
        return {
            myChartList: [],        // mySetting by CHART
            myContentsList: [],     // mySetting by CONTENT, default: ['H', 'W', 'S']

            myChartSettings: [],

            hotContentsList: [],
            workBoardList: [],
            supportList: [],
            newUpdateList: [],

            isContentsLoading: true,
            isChartLoading: true,

            // chart global settings
            chartStyles: { height: '300px', position: 'relative' },
            chartdata: {},
            options: {},

            hotReady: false,
            workReady: false,
            supReady: false,
            newReady: false,
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
    },
    components : {
        'skp-snb'           : SKPSnb,
        'vertical-chart'    : VerticalBarChart,
        'horizontal-chart'  : HorizontalBarChart,
        'pie-chart'         : PieChart,
        'doughnut-chart'    : DoughnutChart,
        'polar-chart'       : PolarAreaChart
    },
    methods : {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            this.mySettingList("CONTENT").then( res => {
                let data = res.data;
                if(data.mySetting.rowCount > 0){
                    this.myContentsList = data.mySetting.rowData;
                };

                this.$nextTick(() => {
                    this.allContentReload();
                    this.isContentsLoading = false;
                });
            });
        },
        async mySettingList(workType) {
            return await fetchMySetting(workType);
        },
        async getContentList(contType) {
            return await fetchContentsList(contType);
        },
        setResponsive(e) {
            if($(window).width() < 1024) { //Mobile & Tablet
                //Mobile GNB
                this.mobileResponsive();

            } else {
                //slick 파괴
                if($('#slide').hasClass('slick-initialized')) {
                    $('#slide').slick("unslick");
                }
            }
        },
        mobileResponsive() {
            this.$nextTick(() => {
                if(!$('#slide').hasClass('slick-initialized')) {
                    $('#slide').slick({
                        dots:true,
                        autoplay:false,
                        autoplaySpeed: 3000,
                        speed: 800,
                        appendDots:'.dots-wrap',
                        arrows: false,
                        fade: true
                    });
                }
            });

            $('.service_tab li > a').on('click', function() {
                $('.service_tab li').removeClass('active');
                $(this).parent().addClass('active');

                $('.mainBtm_box .tab_content').hide();
                var tab_num = $(this).attr("rel");
                $('.mainBtm_box .tab_content:nth-child(' + tab_num + ')').show();
            });
        },
        // 상단 대시보드 차트 설정 팝업
        btnDashboardConfig() {
            SDLUtil.show(
                DashboardConfigPopup,
                {
                    kpiList: this.myChartSettings.rowData,
                    rtnFunc: (isSaved = false) => {
                        SDLUtil.showLoadingBar(true);
                        this.isChartLoading = true;

                        this.$nextTick(() => {
                            if(isSaved){
                                this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                                this.mySettingList("DASHBOARD").then( res => {
                                    let data = res.data;
                                    this.myChartList = data.chartList;
                                    this.myChartSettings = data.mySetting;

                                    this.isChartLoading = false;
                                    SDLUtil.showLoadingBar(false);
                                });

                            } else {
                                this.isChartLoading = false;
                                SDLUtil.showLoadingBar(false);
                            };
                        });
                    }
                },
                { height: 'auto' }
            );
        },
        // 하단 컨텐츠 설정 팝업
        btnContentsConfig() {
            SDLUtil.show(
                ContentsConfigPopup,
                {
                    contList: this.myContentsList,
                    rtnFunc: list => {
                        if(list.length > 0) {
                            this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                            this.myContentsList = list;
                            this.$nextTick(() => {
                                this.allContentReload();
                            });
                        };
                    }
                },
                { height: 'auto' }
            );
        },
        toastPopup(msg) {
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
        allContentReload(params = {}, exWorkKey = []) {
            for(let i = 0; i < this.myContentsList.length; i++) {
                let workKey = this.myContentsList[i].WORK_KEY;
                Object.assign(params, { contType: workKey });
                // HOT Contents
                if(workKey === 'H' && !exWorkKey.includes('H')){
                    this.hotReady = false;
                    this.getContentList(params).then( res => {
                        let data = res.data;
                        this.hotContentsList = data.contentsList.rowData;
                        this.hotReady = true;
                    });

                // Work Board
                } else if(workKey === 'W' && !exWorkKey.includes('W')){
                    this.workReady = false;
                    this.getContentList(params).then( res => {
                        let data = res.data;
                        this.workBoardList = data.contentsList.rowData;
                        this.workReady = true;
                    });

                // Support
                } else if(workKey === 'S' && !exWorkKey.includes('S')){
                    this.supReady = false;
                    this.getContentList(params).then( res => {
                        let data = res.data;
                        this.supportList = data.contentsList.rowData;
                        this.supReady = true;
                    });

                // New & Update
                } else if(workKey === 'N' && !exWorkKey.includes('N')){
                    this.newReady = false;
                    this.getContentList(params).then( res => {
                        let data = res.data;
                        this.newUpdateList = data.contentsList.rowData;
                        this.newReady = true;
                    });
                }
            };

            // SNB Undo reset
            EventBus.$emit('main-snb-undo-reset');
        },
        contentsReload(params, workKey) {
            Object.assign(params, { contType: workKey });
            // HOT Contents
            if(workKey === 'H'){
                this.hotReady = false;
                this.getContentList(params).then( res => {
                    let data = res.data;
                    this.hotContentsList = data.contentsList.rowData;
                    this.hotReady = true;
                });

            // Work Board
            } else if(workKey === 'W'){
                this.workReady = false;
                this.getContentList(params).then( res => {
                    let data = res.data;
                    this.workBoardList = data.contentsList.rowData;
                    this.workReady = true;
                });

            // Support
            } else if(workKey === 'S'){
                this.supReady = false;
                this.getContentList(params).then( res => {
                    let data = res.data;
                    this.supportList = data.contentsList.rowData;
                    this.supReady = true;
                });

            // New & Update
            } else if(workKey === 'N'){
                this.newReady = false;
                this.getContentList(params).then( res => {
                    let data = res.data;
                    this.newUpdateList = data.contentsList.rowData;
                    this.newReady = true;
                });
            }

            // SNB Undo reset
            EventBus.$emit('main-snb-undo-reset');
        },
        // Sidebar 에서 카테고리 선택 후 카테고리 적용하여 컨텐츠 목록 재조회
        setCategory(v) {
            let params = {
                PRD_CATEGORY_CD1: v.searchPRD_CATEGORY_CD1 || '',
                PRD_CATEGORY_CD2: v.searchPRD_CATEGORY_CD2 || '',
                PRD_CATEGORY_CD3: v.searchPRD_CATEGORY_CD3 || ''
            };

            this.allContentReload(params, ['S']);
        },
        /**
         * - HHP_YN = 'Y' 인 경우, HHP 인증 로직 추가 후 컨텐츠 팝업 오픈
         * - 인증이 안될 경우에는 HHP Main 페이지로 이동한다.
         * - 그 외 케이스에는 Knowledge Detail popup 오픈
         */
        popHotContents(contentObj, workKey = 'ALL') {
            let hhpYn = StringUtil.strToBool(contentObj.HHP_YN);
            if(!hhpYn) {
                if(!SDLUtil.isNull(contentObj.SHARE_ID)) {
                    let sharingParams = {
                        knowledgeId: contentObj.KNOWLEDGE_ID, shareId: contentObj.SHARE_ID,
                        rtnFunc: (result) => {
                            // callback function event
                            if(workKey === 'ALL') {
                                this.allContentReload();

                            } else {
                                this.contentsReload({}, workKey);
                            }
                        }
                    };

                    SDLUtil.show(
                        RequestSharingFromPopup,
                        sharingParams,
                        { height: 'auto' }
                    );

                } else {
                    //Knowledge Detail 실행
                    SDLUtil.show(
                        KnowledgeDetailPopup,
                        {
                            KNOWLEDGE_ID: contentObj.KNOWLEDGE_ID,
                            BOARD_ID: contentObj.BOARD_ID,
                            rtnFunc: () => {
                                // callback function event
                                if(workKey === 'ALL') {
                                    this.allContentReload();

                                } else {
                                    this.contentsReload({}, workKey);
                                }
                            }
                        },
                        { height: 'auto' }
                    );
                }

            } else {
                SDLUtil.show(
                    BulletinViewPopup,
                    {
                        seq: contentObj.KNOWLEDGE_ID,
                        rtnFunc: () => {
                            // callback function event
                            if(workKey === 'ALL') {
                                this.allContentReload();

                            } else {
                                this.contentsReload({}, workKey);
                            }
                        }
                    },
                    { height: 'auto' }
                );
            }
        },
        popSupport(key, type) {
            let option = { width: '500px', height: 'auto' };
            let params = {
                searchKey: key,
                rtnFunc: () => {
                    this.getContentList({ contType: 'S' }).then(res => {
                        let data = res.data;
                        if (data.contentsList.rowCount > 0) {
                            this.supportList = data.contentsList.rowData;
                        }
                    });
                },
            };

            if ('QA' === type) {
                SDLUtil.show(questionDetailPopup, params, option);

            } else if ('QP' === type) {
                let param = key.split('^');
                SDLUtil.show(communicationPopup, { param: { questionId: param[0], questionFlowId: param[1] } }, option);

            } else if ('A' === type) {
                SDLUtil.show(answerDetailPopup, params, option);

            } else if ('F' === type) {
                SDLUtil.show(viewFaqPopup, params, option);
            }
        },
        popNewUpdateContents(contentObj) {
            
            let hhpYn = StringUtil.strToBool(contentObj.HHP_YN);
            if(!hhpYn) {
                SDLUtil.show(
                    KnowledgeDetailPopup,
                    {
                        KNOWLEDGE_ID: contentObj.KNOWLEDGE_ID,
                        BOARD_ID: contentObj.BOARD_ID,
                        rtnFunc: () => {
                            // callback function event
                            this.contentsReload({}, 'N');
                        }
                    },
                    { height: 'auto' }
                );
            } else {
                SDLUtil.show(
                    BulletinViewPopup,
                    {
                        seq: contentObj.KNOWLEDGE_ID,
                        rtnFunc: () => {
                            this.contentsReload({}, 'N');
                            // callback function event
                            // if(workKey === 'ALL') {
                            //     this.allContentReload();

                            // } else {
                            //     this.contentsReload({}, workKey);
                            // }
                        }
                    },
                    { height: 'auto' }
                );
            }
        },
        goToDetailPage(chart) {
            const ADMIN_MENU = MenuUtil.getAdminMenu;
            const json = JSON.stringify(this.menus.find(item => ADMIN_MENU.includes(item.menuId) ) );
            const chartType = chart.chartType;

            try {
                if (['MRC', 'IC', 'ICO', 'MRCO'].includes(chartType)) {
                    if (json.includes('LEFT_1000000002')) {
                        this.$router.push({name: 'StatisticsManagerUnreadList'});
                        return;
                    }
                };

                if (['CS'].includes(chartType)) {
                    if (json.includes('LEFT_1000000016')) {
                        this.$router.push({name: 'StatisticsManagerContentsStatisticsNewList'});
                        return;
                    }
                };

                if (['CC', 'CU'].includes(chartType)) {
                    const hasAccess = [
                        'LEFT_0000003505', 'LEFT_0000063726', 'LEFT_0000074941',
                        'LEFT_0000051728', 'LEFT_0000034752', 'LEFT_0000064726',
                    ].some(item => json.includes(item));

                    if (hasAccess) {
                        this.$router.push({name: 'StatisticsManagerContentsStatisticsList'});
                        return;
                    }
                };

                if (['QA'].includes(chartType)) {
                    const hasAccess = [
                        'LEFT_0000000068', 'LEFT_0000074863', 'LEFT_0000034858',
                        'LEFT_0000074782', 'LEFT_0000064731', 'LEFT_0000063703',
                        'LEFT_0000063731', 'LEFT_0000064703', 'LEFT_0000034762',
                        'LEFT_0000051733', 'LEFT_0000080683', 'LEFT_0000051705',
                        'LEFT_0000003510',
                    ].some(item => json.includes(item));

                    if (hasAccess) {
                        this.$router.push({name: 'StatisticsManagerQnAStatusList'});
                        return;
                    }
                };

                if (['RE'].includes(chartType)) {
                    const hasAccess = [
                    'LEFT_0000074937', 'LEFT_0000051742', 'LEFT_0000034759',
                    'LEFT_0000003519', 'LEFT_0000063740', 'LEFT_0000064740',
                    ].some(item => json.includes(item));

                    if (hasAccess) {
                        this.$router.push({name: 'StatisticsManagerReprocessRatioList'});
                        return;
                    }
                };

                SDLUtil.alert( {
                    title: 'No Access',
                    msg: 'You do not have access',
                });

            } catch(e) {
                Vue.$log.error('Menu move catch', e);
                SDLUtil.alert({
                    title: 'No Access',
                    msg: 'You do not have access',
                });
            };

            /*
                ┌────────┬───────────────────────────────────────────┬───────────────────────┐
                | Chart  | Title                                     | Chart Type            |
                ├────────┼───────────────────────────────────────────┼───────────────────────┤
                | IC     | 'Views on @TITLE@ Important Knowledge'    | Horizontal Bar Chart  |
                | MRC    | 'Views on @TITLE@ Must Read Knowledge'    | Horizontal Bar Chart  |
                | CS     | 'Contents Satisfaction on @TITLE@'        | Horizontal Bar Chart  |
                | ICO    | 'Views on @TITLE@'                        | Doughnut/Pie chart    |
                | MRCO   | 'Views on @TITLE@'                        | Doughnut/Pie chart    |
                | QA     | 'Q&A Status on @TITLE@'                   | Doughnut/Pie chart    |
                | CU     | 'Contents Usage on @TITLE@'               | Vertical Bar Chart    |
                | RE     | 'Reprocessing Ratio on @TITLE@'           | Vertical Bar Chart    |
                | CC     | 'Contents Creation on @TITLE@'            | Polar Area chart      |
                └────────┴───────────────────────────────────────────┴───────────────────────┘

                Important(only)/Must-Read(only)         Unread Status
                LEFT_1000000002

                Contents Creation/Contents Usage         Contents Log
                LEFT_0000003505
                LEFT_0000063726
                LEFT_0000074941
                LEFT_0000051728
                LEFT_0000034752
                LEFT_0000064726

                Reprocessing                            Reprocess Ratio
                LEFT_0000074937
                LEFT_0000051742
                LEFT_0000034759
                LEFT_0000003519
                LEFT_0000063740
                LEFT_0000064740

                Contents Satisfaction                    Contents Satisfaction
                LEFT_1000000016

                Q&A Status                                Q&A Status
                LEFT_0000000068
                LEFT_0000074863
                LEFT_0000034858
                LEFT_0000074782
                LEFT_0000064731
                LEFT_0000063703
                LEFT_0000063731
                LEFT_0000064703
                LEFT_0000034762
                LEFT_0000051733
                LEFT_0000080683
                LEFT_0000051705
                LEFT_0000003510
            */
        },
    },
    created() {
        this.initLoad();
        this.$nextTick(() => {
            window.addEventListener('resize', this.setResponsive);
            // Snb Event
            EventBus.$on('quick-category', v => { this.setCategory(v); });
        });

        // loading complete
        SDLUtil.showLoadingBar(false);
    },
    mounted() {
        this.$nextTick(() => {
            SDLUtil.importJS(`${this.$CONTEXT}/static/js/slick.min.js`)
                .then(() => {
                    this.mySettingList("DASHBOARD").then( res => {
                        let data = res.data;
                        this.myChartList = data.chartList;
                        this.myChartSettings = data.mySetting;
                        //console.log('Yame::myChartSettings',this.myChartSettings);
                        //console.log('Yame::myChartList',this.myChartList);
                        // 차트 로딩 확인
                        this.$nextTick(() => {
                            this.isChartLoading = false;
                            if(SDLUtil.isMobile()) {
                                this.mobileResponsive();

                            } else {
                                this.setResponsive();
                            }
                        });
                    });
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
            }
        );
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setResponsive);
        EventBus.$off('quick-category');
    },
};
</script>
<style scoped>
.mainBtm_box .ul_list li.nodata > span {display:table-cell;height:400px;vertical-align:middle;font-size:14px;font-weight:bold;}
.mainBtm_box .ul_list li.nodata > span img {vertical-align:middle;margin-right:20px;}
.mgleft {margin-left: 105px;}
.chart-block {
    max-width: 500px;
    max-height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/Dashboard.vue